

<!-- header #1 -->
<nav class="navbar navbar-expand-lg navbar-light header-1-cus p-0">
  <div class="align-items-center container-fluid d-flex gap-3 header-style-cus">

    <!-- company logo -->
    <a
      href="/"
      class="d-flex align-items-center col-1 mb-2 mb-md-0 text-dark text-decoration-none w-auto"
      routerLink="/"
    >
      <div class="company-logo d-flex gap-2">
        <img [src]="logo_img" class="app-logo ms-1">
      </div>
    </a>

    <!-- offcanvas toggle button -->
    <button
      class="navbar-toggler mobile-top-nav-btn mb-2  border-0 shadow-none"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#header-nav"
      aria-controls="navbarTogglerDemo02"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- toggle content -->
    <div
      class="offcanvas offcanvas-start w-100"
      tabindex="-1"
      id="header-nav"
      aria-labelledby="offcanvas_top_nav"
      data-bs-scroll="true"
      data-bs-backdrop="false"
    >
      <!-- offcanvas header -->
      <div class="offcanvas-header header-1-cus">
        <h5 class="offcanvas-title" id="offcanvasExampleLabel"></h5>
        <button
          type="button"
          class="btn-close mobile-close-btn-cus shadow-none"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          #offcanvas_close_btn
        ></button>
      </div>

      <!-- offcanvas body -->
      <div class="offcanvas-body ms-0 header-1-cus">

        <!-- offcanvas body -->
        <ul class="col-md-auto flex-column flex-lg-row gap-3 justify-content-between mb-2 mb-md-0 nav navbar-nav w-100 align-items-center pe-3">




          <!-- delivery element -->
          <div class="align-items-center d-flex gap-2 gps-box" *ngIf="has_takeaway">

            <div>
              <div class="d-flex gap-1" style="cursor: pointer" (click)="showBranches(); close_mobile_nav(offcanvas_close_btn);">
                <p class="m-0 fs-5 text-color-style fs-14-cus">{{ "delivery_title" | translate : "header" }}</p>
                <div class="align-items-center d-flex">
                  <button
                    type="button"
                    icon="pi pi-info-circle"
                    label="Show"
                    class="border-0"
                    style="background-color: var(--primary-color)"
                  >

                    <svg viewBox="0 0 20 20" aria-hidden="true" focusable="false" version="1.1" xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="20"
                    fill="#fff"
                    stroke="#fff"
                    stroke-width="0"
                    class="border mb-1 p-1 rounded-3"
                    >
                      <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                    </svg>

                  </button>
                </div>
              </div>

              <!-- active branch -->
              <div class="d-flex">
                <p class="m-0 fs-5 fw-bold text-color-style fs-14-cus">
                  {{ selected_location }}
                </p>
              </div>


            </div>

          </div>




          <!-- search input -->
          <div class="position-relative bg-white col d-flex px-2 py-1 search-box rounded rounded-2">

            <div class="bg-white col d-flex py-1 search-style-cus">
              <input
              type="search"
              pInputText
              [(ngModel)]="search_value"
              (input)="searching($event);"
              placeholder="{{ 'search_text' | translate : 'header' }}"
              class="shadow-none"
              #search_input
              />
            </div>


            <!-- TODO: return this later after finishing language system -->
            <!-- <div
            class="align-items-center d-flex mb-0 position-absolute search-icon-box top-50 translate-middle"
            [ngClass]="{ 'start-0 ms-4' : lang == 'ar', 'end-0' : lang == 'en' }"
            >
              <svg fill="#bbb" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
                <path d="M790.588 1468.235c-373.722 0-677.647-303.924-677.647-677.647 0-373.722 303.925-677.647 677.647-677.647 373.723 0 677.647 303.925 677.647 677.647 0 373.723-303.924 677.647-677.647 677.647Zm596.781-160.715c120.396-138.692 193.807-319.285 193.807-516.932C1581.176 354.748 1226.428 0 790.588 0S0 354.748 0 790.588s354.748 790.588 790.588 790.588c197.647 0 378.24-73.411 516.932-193.807l516.028 516.142 79.963-79.963-516.142-516.028Z" fill-rule="evenodd"/>
              </svg>
            </div> -->

            <div
            class="position-absolute list-group list-group-flush scrollarea search-results-box w-100 bg-white"
            *ngIf="show_results_view && search_results?.length"
            >
              <a
              href="javascript: void(0);"
              class="list-group-item list-group-item-action lh-tight search-result-box"
              *ngFor="let result of search_results;"
              (click)="search_result_clicked(result, search_input); close_mobile_nav(offcanvas_close_btn);"
              >
                <div class="d-flex w-100 align-items-center gap-2">
                  <strong class="mb-1">{{ result.name }}</strong>
                  <strong class="mb-1 text-success" *ngIf="result?.brand">({{ result?.brand?.name }})</strong>
                </div>
              </a>
            </div>

          </div>


          <!-- item#3 -->
          <div class="d-flex align-items-center">


            <!-- language -->
            <div class="d-flex" style="cursor: pointer">

              <div>
                <select
                class="form-select shadow-none"
                aria-label="language select"
                (change)="facades?.switchlang($event, langs); language_selector.disabled=true; language_selector.classList.add('lang-disabled');"
                #language_selector
                >

                  <option
                  *ngFor="let lang of langs; let i = index;"
                  [attr.selected]="lang.code == active_language.code ? true : null"
                  [value]="i"
                  >
                    {{ lang?.name }}
                  </option>

                </select>
              </div>

              <div class="divider-style-cus"></div>

            </div>


            <!-- profile -->
            <div class="d-flex" style="cursor: pointer" *ngIf="is_signed_in">
              <div routerLink="/my-account/my-profile">
                <p class="m-0 fs-5 fs-14-cus text-color-style fw-bold" (click)="close_mobile_nav(offcanvas_close_btn);">
                  {{ "profile" | translate: "header" }}
                </p>
              </div>

              <div class="divider-style-cus"></div>
            </div>


            <!-- sign in -->
            <div
            class="d-flex gap-2 align-items-center"
            style="cursor: pointer"
            (click)="showDialog('sign-in'); close_mobile_nav(offcanvas_close_btn);"
            *ngIf="!is_signed_in"
            >

              <div>
                <button
                style="border: none"
                type="button btn"
                icon="pi pi-info-circle"
                label="Show"
                >
                  <p class="m-0 fs-5 fs-14-cus text-color-style fw-bold" style="background-color: var(--primary-color)">
                    {{ "sign_in" | translate: "header" }}
                  </p>
                </button>
              </div>

              <div class="align-items-center d-flex">
                <svg class="icon-user" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 337.62 384"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M8.31,384c-6.67-3.08-8.44-8.37-8.3-15.48,1.33-68.91,53.87-130.15,121.72-141.26a182.73,182.73,0,0,1,25.71-2.16c15.24-.34,30.5-.55,45.73,0C251,227.24,293.31,254.66,321,304.94c10.9,19.79,15.64,41.41,16.59,63.95.3,7-1.82,12.1-8.28,15.11Z"/><path d="M177.06,0c7.65,1.66,15.51,2.69,22.94,5.07,44.05,14.14,73.47,57.56,69.88,102.6-3.82,48-38.27,85.89-84.86,93.46A101.2,101.2,0,0,1,68.13,111.39C62.5,56.27,102.74,6.51,157.67.65A25,25,0,0,0,160.56,0Z"/></g></g></svg>
              </div>

              <div class="divider-style-cus"></div>

            </div>


            <!-- sign out -->
            <div
            class="d-flex gap-2 align-items-center"
            style="cursor: pointer"
            (click)="signing_out(); close_mobile_nav(offcanvas_close_btn);"
            *ngIf="is_signed_in"
            >

              <div>
                <button
                style="border: none"
                type="button btn"
                icon="pi pi-info-circle"
                label="Show"
                >
                  <p class="m-0 fs-5 fs-14-cus text-color-style fw-bold" style="background-color: var(--primary-color)">
                    {{  "sign_out" | translate: "header"  }}
                  </p>
                </button>
              </div>

              <div class="align-items-center d-flex" style="margin-bottom: -4px;">
                <svg class="icon-signout" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M177,512H164c-3-.94-6-1.84-8.93-2.82-41.59-13.83-83.21-27.59-124.76-41.56C14.63,462.34,4.67,451.54.92,435.26A14.67,14.67,0,0,0,0,433V36c.42-1.21.89-2.4,1.24-3.64Q7.48,10.24,29,2.25C31.33,1.41,33.68.75,36,0H285c1.26.34,2.51.79,3.79,1,27.74,4.87,51,29.57,52,57,.9,23.8.34,47.66.27,71.49,0,6.19-2.94,11.25-7.73,15-6.73,5.34-14.3,6.33-22.08,2.85-8-3.58-12.41-10-12.47-18.87-.16-20.5-.06-41-.09-61.5,0-15.74-8.38-24.21-23.94-24.23q-44.51,0-89,0c-1.44,0-2.88.13-4.49.2.35.52.46.88.68,1,23.35,9.89,31.25,21.83,31.26,47.22V405.25H274c16.57,0,24.69-8.23,24.7-25q0-39.5,0-79a33.21,33.21,0,0,1,.79-8.41c2.66-9.9,12.51-16.58,22.32-15.44,11.13,1.29,19.17,9.53,19.25,20.65q.32,42.75.06,85.5C341,420.22,313,447.87,276.33,448c-19.17.06-38.33,0-57.5,0h-5.68c0,8.25.21,15.73-.05,23.2-.46,13.31-6,24.39-16.88,31.92C190.51,507.08,183.45,509.1,177,512Z"/><path d="M512,218c-3.88,5.28-7.19,11.13-11.74,15.75-26,26.35-52.25,52.39-78.37,78.58-5.65,5.67-12.17,8.75-20.24,7.3-10.6-1.9-17.57-10.48-17.62-21.69-.09-19,0-38,0-57v-6.2H378c-25.83,0-51.66,0-77.49,0-11.91,0-20.52-6.66-22.62-17.15C275.12,204,285,192.08,299.35,192c26.16-.1,52.32,0,78.49,0H384v-5.52c0-18.83.08-37.66,0-56.49-.06-10,3.85-17.67,13.16-21.54s17.52-1.35,24.59,5.74c27.65,27.73,55.43,55.32,82.95,83.18,3.15,3.19,4.92,7.72,7.33,11.63Z"/></g></g></svg>
              </div>

              <div class="divider-style-cus"></div>

            </div>



            <div
              class="d-flex align-items-center position-relative"
              style="cursor: pointer"
              (click)="open_cart(); close_mobile_nav(offcanvas_close_btn);"
              *ngIf="show_cart"
            >


              <div class="position-relative">
                <div class="align-items-center d-flex">
                  <svg class="icon-cart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 378.59 368.19"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M0,12.68C3.48,3.07,10.52-.28,20.44,0c13.49.41,27,.1,40.5.1,11,0,15.78,3.49,19.29,14Q86.86,34.05,93.5,53.93c2.74,8.18,5.69,10.32,14.27,10.32q125.84,0,251.68,0a30.74,30.74,0,0,1,7.44.54c9.22,2.33,13.88,11.62,10.71,21.3-5.36,16.35-10.82,32.68-16.26,49q-12.6,37.82-25.24,75.61c-3.3,9.89-8.18,13.46-18.52,13.46H152.17c-9.66,0-12,1.82-14.39,11.1-.83,3.26-1.75,6.51-2.48,9.79-1.29,5.91,2,10.42,8,11.08a42.14,42.14,0,0,0,4.5.09q92.64,0,185.28,0a27.29,27.29,0,0,1,8.48,1c7.28,2.4,11.37,9.75,10.23,17.57a15.83,15.83,0,0,1-14.72,13.19c-1,.06-2,.06-3,.06q-94.32,0-188.66,0c-20.81,0-37.16-13.09-41.53-33.08a40.14,40.14,0,0,1,.62-18.93c7.52-28.92,7-26.82-2.25-54.48Q78.88,111.7,55.63,41.72C53.21,34.45,50,32.2,42.36,32.19c-7.5,0-15-.31-22.5.07C10,32.76,3.25,28.93,0,19.43Z"/><path d="M123,368.19a96,96,0,0,1-9-3.32A31.75,31.75,0,0,1,97.27,327.5c4.33-15.21,18.39-24.57,34.6-23.05,14.29,1.33,26.85,14.08,27.94,28.37,1.25,16.29-8.28,30.14-23.54,34.26-1.18.32-2.33.74-3.49,1.11Z"/><path d="M315.07,368.19a96,96,0,0,1-9-3.32,31.76,31.76,0,0,1-16.74-37.37c4.33-15.21,18.38-24.57,34.59-23.05,14.3,1.33,26.85,14.08,27.95,28.37,1.24,16.29-8.28,30.14-23.54,34.26-1.18.32-2.33.74-3.49,1.11Z"/></g></g>
                  </svg>
                </div>

                <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger badge-cus">
                  {{ number_of_cart_items }}
                  <span class="visually-hidden">{{"unread messages" }}</span>
                </span>
              </div>

              <div class="divider-style-cus"></div>

            </div>

            <button
            class="align-items-center bg-transparent border-0 d-flex gap-1 position-relative"
            style="cursor: pointer"
            (click)="toggleNotifocations(); close_mobile_nav(offcanvas_close_btn);"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#notification_offcanvas_modal"
            aria-controls="notification_offcanvas_modal"
            >

              <div class="align-items-center d-flex">
                <svg class="icon-bell" fill="#fff" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24" xml:space="preserve">
                <style type="text/css">
                  .st0{fill:none;}
                </style>
                <g id="surface1">
                  <path d="M12,2c-0.8,0-1.5,0.7-1.5,1.5v0.7C7.3,4.9,5,7.6,5,11v4.5l-2,2.3V19h18v-1.2l-2-2.3V11c0-3.4-2.3-6.1-5.5-6.8V3.5
                    C13.5,2.7,12.8,2,12,2z M10,20c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2H10z"/>
                </g>
                <rect class="st0" width="24" height="24"/>
                </svg>
              </div>

              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger badge-cus">
                {{ notifications?.length || 0 }}
                <span class="visually-hidden">{{"unread messages"}}</span>
              </span>

            </button>


          </div>
        </ul>
      </div>
    </div>

  </div>
</nav>





<lib-base-header-componenet/>

